import jsbridge from '@kkmh/jsbridge';
import {
    ua,
    qs,
    debug as loging,
    getDeepVal,
} from '@kkmh/utils'
//hybrid方法
const hybrid = (options) => {
    //requestHybrid时所传递过schema/tagname/param/callback
    var schema      = options.schema || 'kkhybrid';
    var tagname     = options.tagname || '';
    var param       = options.param || {};
    var callback    = options.callback || '';

    //requestHybrid_wk 可以在接收is_del_nativecallback/debug
    var is_del_nativecallback = options.is_del_nativecallback === false ? false : true;
    var debug = options.debug === true ? true : false;
    if (/jsbridge_debug=true/.test(location.href)) {
        debug = true;
    }
    /**
     * * jsbridge : 使用@kkmh/jsbridge@1.0.3 : https://wiki.quickcan.com/pages/viewpage.action?pageId=122488334
     * 参数
     * options={
     *    @schema               : 'kkhybrid',               //string-Y: kkmhhybrid, kkhybrid, kkaction, kkmh, window...
     *    @tagname              : 'login_win',              //string-Y: 方法名称
     *    @param                : '{id : 123}',             //object-Y: 参数
     *    @callback             : function(res, nativecallback_name){},     //function-N: 回调函数
     *    @is_del_nativecallback: true,                     //boolean-N: 默认true 删除客户端回调函数 (删除那个随机创建的函数名)
     *    @debug                : false,                    //boolean-N: 默认false 不输出log
     * }
     *
     * 返回:无
     * **/
     
     var obj = {
        schema      : schema,           //string : kkmhhybrid, kkhybrid, kkaction ...
        tagname     : tagname,          //string : 方法名称
        param       : param,            //object : 所传递参数
        callback    : function(res, cbnm){    //string : native调用js回调函数
            if (typeof res == 'string') res = JSON.parse(res);
            // loging(`[${tagname}返回]`,JSON.parse(JSON.stringify(res)));
            callback && callback(res,cbnm)
        },   
        is_del_nativecallback : is_del_nativecallback,
        debug       : debug
    }

    // ******* 判断浏览器环境，kuaikan-chrome是模拟器 *******
    if (!/kuaikan\//.test(navigator.userAgent.toLowerCase()) || /kuaikan-chrome/.test(navigator.userAgent.toLowerCase())) {
        var res = {};
        typeof callback === "function" && callback(res);
    } else {
        jsbridge(obj);    
    }
}

[
    'subscribeListenerOnViewBack',  //监听webview切换
    'recivefreecardinfo',           //监听王卡变化
    'getLoginStatus',               //kkaction的一个协议回调名固定的
].forEach((fn) => {
    window[fn] = function(){};
})
let request_record      = {};
let current_login_mode  = '';
let is_first_init       = false; // 是否执行过一次
let count_num           = 0;
let time_record         = {};
window.__gvalkkmh       = {
    is_called_handshake : false,
    is_called_loginwindow : false,
    is_track_identified : false,
    ua,
    param : qs,
    user : {},
    sys : {},
}

const LOGIN_UNWANTED        = 'unwanted'; //不需登录
const LOGIN_NEED            = 'need';     //需要弹窗登录 （判断是否已登录）
const LOGIN_MUST            = 'must';     //强制弹窗登录（不判断是否已登录，处理401/402等接口code）
const IS_HANDSHAKE_VER      = ua.appversion >= 550000 || false; //
const IS_SYSINFO_VER        = ua.appversion >= 582000 || false; // 新协议迁移时要get_user里加性别，版本未定
const IS_POPLOGIN_VER       = ua.appversion > 560000 || false; // 较稳定登录版本
const IS_WKUSEAJAX_LOWVER   = (window.__gvalkkmh.ua.wkwebview && ua.appversion <= 572000) || false; // wkwebview登录框消失后接口请求偶现失败，572000修复
const KKMHHYBRID            = 'kkmhhybrid';
const KKHYBRID              = 'kkhybrid';
const KKACTION              = 'kkaction';
const KKHYBRIDAPI           = 'kkhybridapi';
const TAGNAMES              = {
    //kkmhhybrid
    'handshake'         : {schema : KKMHHYBRID},
    'get_sys'           : {schema : KKMHHYBRID},
    'get_user'          : {schema : KKMHHYBRID},
    'get_freecard'      : {schema : KKMHHYBRID},
    'logout_new'        : {schema : KKMHHYBRID},
    'login'             : {schema : KKMHHYBRID, is_del_nativecallback : false},
    //kkaction
    'getSysDeviceInfo'  : {schema : KKACTION},
    //kkhybridapi
    'scrollwhitearea'   : {
        schema : KKHYBRIDAPI,
        param  : {
            conf2scrollwhitearea : 1,//去掉白边
        }
    },
    //kkhybrid
    'login_result'      : {schema : KKHYBRID},
    'logout'            : {schema : KKHYBRID},
    'login_win'         : {schema : KKHYBRID},
    'header'            : {
        schema  : KKHYBRID,
        param   : {
            config      : 'screen',
            display     : 1, //默认是1：竖屏，2：横屏
            fullScreen  : 'show', //show是全屏幕,hide是显示topbar
            data        : {}
        }
    },
}
/**
 * res 3种结果
 * 1. {device_id:''}
 * 2. { errno=0, data={}, msg='' }
 * 3. { code=200, data={}, message='ok' }
 * **/

const formatRes = (res, tagname) => {
    let { code, errno, data, message, msg } = res;
    if (tagname == 'getSysDeviceInfo') {
        data = res;
    }
    return {
        code : code || errno || 0,
        message : message || msg || '',
        data : data || {},
    }
}
const request = (tagname) => {
    return new Promise(resolve => {
        let item = TAGNAMES[tagname];
        if (!item) {
            resolve(formatRes({message:`${tagname}-未定义的协议名称`}));
        }

        if (tagname == 'logout_new') tagname = 'logout';//与老协议名冲突

        let options = {
            tagname : tagname, 
            schema  : item.schema,
            param   : item.param || {},
            is_del_nativecallback : item.is_del_nativecallback==false ? false : true,
        }

        setRequestRecord(tagname, options);

        hybrid({ 
            tagname : options.tagname, 
            schema  : options.schema,
            param   : options.param,
            is_del_nativecallback   : options.is_del_nativecallback,
            callback : (res) => {
                setResponseRecord(tagname, res);

                if (!/kuaikan\//.test(navigator.userAgent.toLowerCase()) || /kuaikan-chrome/.test(navigator.userAgent.toLowerCase())) {
                    resolve(formatRes(res, tagname));
                }
                if (tagname == 'login') {
                    // path_step 0->打开登录窗体 1->关闭登录窗口
                    if (getDeepVal(res,'data.path_step',0) == 1) {
                        // is_success_login 0-> 没有登录 1->登录成功
                        resolve(formatRes(res, tagname));
                    }
                } else {
                    resolve(formatRes(res, tagname));    
                }
            }
        })
    });
}
const setRequestRecord = (tagname, options) => {
    time_record[`request-${tagname}`] = new Date().getTime();

    let key = `${PrefixZero(count_num++)}.request-${tagname}`;
    request_record[key] = options;
}
const setResponseRecord = (tagname, res) => {
    let t = new Date().getTime() - time_record[`request-${tagname}`];

    let key = `${PrefixZero(count_num++)}.response-${tagname}-耗时${t}ms`;
    request_record[key] = res;
}
function PrefixZero(num) {
    return (Array(2).join(0) + num).slice(-2);
}
/**
 *  {
 *      code : 0,
 *      data : {
 *          "sdk_version": 100000,
 *          "app_version": 559001,   //数字
 *          "app_version_name": "5.59.1",  //字符串
 *          "os_version": "11.3.1",
 *          "device_id": "I:16371F40-...",
 *          "platform":'android',//ios
 *          "wifi": true,
 *          "carrier": "中国联通",
 *          "model": "iPhone9,2",
 *      },
 *      message : '',
 *  }
 * **/
const handshake = () => {
    return new Promise(resolve => {
        if (IS_HANDSHAKE_VER && !window.__gvalkkmh.is_called_handshake) {
            request('handshake').then((res) => {
                window.__gvalkkmh.is_called_handshake = true;
                window.__gvalkkmh.sys.wifi = res.data.wifi || false;
                window.__gvalkkmh.sys.app_version = parseInt(res.data.app_version) || 0;
                resolve();
            })
        } else {
            resolve();
        }
    })
}

//设置cookie - 本地ip可调试 && 也能解决线上ios-wkwebview问题（之前登录后请求未能同步至h5域名cookie，572000 版本修复）
const setUserSession = () => {
    if (window.__gvalkkmh.user.session) {
        window.__gvalkkmh.user.session.split(";").forEach((item) => {
            var domain = '';//获取一级域名(domain=.kuaikanmanhua.com;)
            if(/\.com|\.cn/.test(location.hostname)) {
                 domain = 'domain=.'+location.hostname.split('.').slice(-2).join('.')+';';
            }
            var Days = 15;
            var exp = new Date();
            exp.setTime(exp.getTime() + Days*24*60*60*1000);
            var cookie = item + ";"+ domain +"path=/;expires=" + exp.toGMTString()+"";
            document.cookie = cookie;
        });
    }
}

//去掉客户端白
const setIosWhiteArea = () => {
    if(
        window.__gvalkkmh.ua.iphone && 
        !/conf2scrollwhitearea/.test(location.href) && 
        !is_first_init
    ) {
        request('scrollwhitearea');
    } 
}
//设置竖全屏
const setFullScreen = () => {
    if (/conf2fullscreen=1/.test(location.href) && window.__gvalkkmh.ua.local && !is_first_init) {
        request('header');
    }
}

//初始化埋点信息
const setTrack = () => {
    let uid = window.__gvalkkmh.user.id;
    let did = window.__gvalkkmh.sys.device_id;
    if (typeof kksa != "undefined") {
        let track_id = uid ? uid.toString() : did;
        if (track_id) {
            kksa.identify(track_id);
            kksa.is_identified = true;
            window.__gvalkkmh.is_track_identified = true;
        }

        if (/kksa_identify=true/.test(location.href)) {
            kksa.is_identified = true;
            window.__gvalkkmh.is_track_identified = true;
        }
    }
}

const sysinfo = (mode) => {
    return new Promise(resolve => {
        if (IS_SYSINFO_VER) {
            getSysNew(mode).then(() => {
                resolve();
            });
        } else {
            getSysOld(mode).then(() => {
                resolve();
            });
        }
    });
}
const getSysNew = (mode) => {
    return new Promise(resolve => {
        if (mode == 'update_user') {
            request('get_user').then((res_user) => {
                let data_user = res_user.data || {};
                data_user.uid = data_user.id || 0;
                setUser(data_user)
                resolve();
            });
        } else {
            Promise.all([request('get_sys'),request('get_user'),request('get_freecard')]).then((arr) => {
                let data_sys = getDeepVal(arr[0],'data.sys',{});
                let data_user = arr[1].data || {};
                let data_freecard = arr[2].data || {};

                let wifi = window.__gvalkkmh.sys.wifi;
                let app_version = window.__gvalkkmh.sys.app_version;
                window.__gvalkkmh.sys = {
                    muid            : data_sys.muid || '',
                    device_id       : data_sys.device_id || '',
                    app_version     : app_version,
                    app_info        : data_sys.app_info || '',
                    is_jailbroken_phone: data_sys.is_jailbroken_phone || false,//是否越狱手机
                    package_id      : data_sys.package_id || '',
                    //新协议:handshake/get_network里获取
                    wifi            : wifi,
                    //新协议:get_freecard里获取
                    kkflowtype      : data_freecard.kkflowtype || false,
                    gender          : data_user.gender || '',
                    manufacturer    : data_sys.manufacturer || '', //厂商
                    model           : data_sys.model || '', //型号
                    screen_height   : data_sys.screen_height || 0, //屏幕高
                    screen_width    : data_sys.screen_width || 0, //屏幕宽
                    abtest_sign     : data_sys.abtest_sign || [], //
                    os_version      : data_sys.os_version || '', //系统版本

                }
                data_user.uid = data_user.id || 0;
                setUser(data_user)
                resolve();
            })
        }
    });
}
const getSysOld = (mode) => {
    return new Promise(resolve => {
        if (mode == 'update_user') {
            request('login_result').then((res_user) => {
                let data_user = res_user.data || {}
                setUser(data_user)
                resolve();
            });
        } else {
            Promise.all([request('getSysDeviceInfo'),request('login_result')]).then((arr) => {
                let data_sys    = arr[0].data || {};
                let data_user   = arr[1].data || {};
                window.__gvalkkmh.sys = {
                    muid            : data_sys.muid || '',
                    device_id       : data_sys.device_id || '',
                    app_version     : parseInt(data_sys.app_version) || 0,
                    app_info        : data_sys.app_info || '',
                    is_jailbroken_phone: data_sys.is_jailbroken_phone || false,//是否越狱手机
                    package_id      : data_sys.package_id || '',
                    //新协议:handshake/get_network里获取
                    wifi            : data_sys.wifi || false,
                    //新协议:get_freecard里获取
                    kkflowtype      : getDeepVal(data_sys,'freecard.kkflowtype', false),
                    gender          : data_sys.gender || '',
                    manufacturer    : data_sys.manufacturer || '', //厂商
                    model           : data_sys.model || '', //型号
                    screen_height   : data_sys.screen_height || '', //屏幕高
                    screen_width    : data_sys.screen_width || '', //屏幕宽
                    abtest_sign     : data_sys.abtest_sign || [], //
                    os_version      : data_sys.os_version || '', //系统版本
                }
                setUser(data_user)
                resolve();
            });
        }
    });
}
const setUser = (data_user) => {
    window.__gvalkkmh.user = {
        id      : data_user.uid || 0,
        session : data_user.session || '',
    }
}

const popLogin = () => {
    return new Promise(resolve => {
        if (window.current_login_mode == LOGIN_MUST) {
            doLogout().then(() => {
                window.__gvalkkmh.is_called_loginwindow = true;
                doLogin().then((is_logined) => {
                    resolve(is_logined);
                });
            });
        }
        if (window.current_login_mode == LOGIN_NEED && !window.__gvalkkmh.user.id) {
            window.__gvalkkmh.is_called_loginwindow = true;
            doLogin().then((is_logined) => {
                resolve(is_logined);
            });
        } 
        if (window.current_login_mode == LOGIN_NEED && window.__gvalkkmh.user.id) {
            resolve(false);    
        }
    });
}

const doLogout = () => {
    return new Promise(resolve => {
        if (IS_POPLOGIN_VER) {
            request('logout_new').then(() => {
                resolve();
            });
        } else {
            request('logout').then(() => {
                resolve();
            });
        }
        window.__gvalkkmh.user = {};
    });
}
const doLogin = () => {
    return new Promise(resolve => {
        if (IS_POPLOGIN_VER) {
            request('login').then((res) => {
                let is_logined = getDeepVal(res, 'data.is_success_login', 0)==1 || false;
                coverWkwebviewError(resolve,is_logined);// 修复wk问题
            });
        } else {
            request('login_win').then((res) => {
                let is_logined = getDeepVal(res, 'data.status', 0)==1 || false;
                coverWkwebviewError(resolve,is_logined);// 修复wk问题
            });
        }
    });
}
/*
 * 解决版本：ios wk-5.72
 * 问题描述wkwebview下 早期版本存在问题。（登录框未消失前调用接口偶现异常发送错误，采用监听H5可见后在往后执行）
 * 弃用原因，监听在未登录关闭时比login前执行，登录成功关闭时login后执行。（太费劲儿啦怎么判断这次是提前执行的还是后执行的）
 * 改用延时解决吧。
*/
const coverWkwebviewError = (resolve,is_logined) => {
    if (is_logined) {
        docoverWkwebviewError().then(() => {
            resolve(is_logined);
        });
    } else {
        resolve(is_logined);
    }
}
const docoverWkwebviewError = () => {
    return new Promise(resolve => {
        if (IS_WKUSEAJAX_LOWVER) {
            setTimeout(() => {
                console.log('sleep30');
                resolve();
            },30);
        } else {
            resolve();
        }
    })
}
// const coverWkwebviewError = (over) => {
//     return new Promise(resolve => {
//         if (window.__gvalkkmh.ua.wkwebview && IS_WKUSEAJAX_LOWVER) {
//             let options = { 
//                 schema  : 'kkmhhybrid', 
//                 tagname : 'receive_page_status',
//                 is_del_nativecallback   : false,
//             }
//             setRequestRecord(options.tagname, options);
//             hybrid({
//                 schema : options.schema,
//                 tagname : options.tagname,
//                 is_del_nativecallback : options.is_del_nativecallback,
//                 callback : (res, nativecallback_name) => {
//                     setResponseRecord(options.tagname, res);
//                     //param-curr_page_is_visible : 0不可见，1.可见
//                     //param-action_origin: 1-webview和webview之间跳转，2-webview和native之间跳转，3-webview和第三方app跳转或后台运行时切换
//                     //param-route_source_name :'comic' //端内的来源页面
//                     //[andorid] 初始化时会返回 1 0 '' 所以保守拿三个字段来判断，登录后h5是否显示了
//                     if (
//                         getDeepVal(res,'data.curr_page_is_visible',0) == 1 && 
//                         getDeepVal(res,'data.action_origin',0) == 2 && 
//                         getDeepVal(res,'data.route_source_name','')
//                     ) {
//                         over();
//                         if (window.__gvalkkmh.ua.iphone) {
//                             delete window[nativecallback_name];    
//                         } else {
//                             //删除cbname,android会报红undefined
//                             window[nativecallback_name] = () => {};    
//                         }
//                     }
//                 }
//             });
//             resolve(true);
//         } else {
//             resolve(false);
//         }
//     })
// }

/**
 * * h5init : 初始化h5 [ua, qs, hybrid(handshake/sysinfo/logininfo/fullscreen/whitearea/ ...)]
 * 参数
 * options={
 *    @login_mode   : 'unwanted',       //string : unwanted[default], need, must           
 * }
 *
 * 返回:无
 * **/
const verifyLoginMode = (login_mode) => {
    if (login_mode !== LOGIN_UNWANTED && login_mode !== LOGIN_NEED && login_mode !== LOGIN_MUST) {
        window.current_login_mode = LOGIN_UNWANTED;
    } else {
        window.current_login_mode = login_mode;
    }
}

const h5init = ({login_mode=''} = {}) => {
    window.w_t1 = new Date().getTime();
    verifyLoginMode(login_mode);
    return new Promise(resolve => {
        // if (!window.__gvalkkmh.ua.kkmh) {
        //     resolve();
        //     return;
        // }
        handshake().then(() => {
            switch(window.current_login_mode) {
                case LOGIN_UNWANTED:
                    sysinfo().then(() => {
                        h5initAfter(resolve);
                    });
                break;
                case LOGIN_NEED:
                    sysinfo().then(() => {
                        h5initPoplogin(resolve);
                    });
                break;
                case LOGIN_MUST:
                    h5initPoplogin(resolve);
                break;
            }
        });
    });
}
const h5initPoplogin = (resolve) => {
    popLogin().then((respopLogin) => {
        if (respopLogin) {
            sysinfo('update_user').then(() => {
                h5initAfter(resolve);
            });
        } else {
            h5initAfter(resolve);
        }
    });
}
const h5initAfter = (resolve) => {
    setTrack();
    setUserSession();
    setIosWhiteArea();
    setFullScreen();
    is_first_init = true; //初始化标记
    resolve(window.__gvalkkmh);

    // 日志输出
    window.w_t2 = new Date().getTime();
    loging(`【h5init(${window.current_login_mode}模式)-数据返回】`,window.__gvalkkmh);
    loging(`【h5init(${window.current_login_mode}模式)-协议记录】`,request_record);
    loging(`【h5init(${window.current_login_mode}模式)-总耗时:】${w_t2-w_t1}ms]`);
    setTimeout(() => {
        request_record = {};
        count_num = 0;
    },1000)
}

export default h5init








// WEBPACK FOOTER //
// ./node_modules/@kkmh/h5init/src/h5init.js